<template>
  <div>
    <v-toolbar class="my-md-auto" elevation="0"  >
      <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
        <h1><v-icon large>mdi-book</v-icon>{{$t('process.fields')}}</h1>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          color=""
          class="ml-sm-2"
          @click="resetForm"
        >
          {{ $t('global.reset')}}
        </v-btn>
        <v-btn
          :loading="isLoading"
          class="ml-sm-2"
          color="primary"
          @click="onSendForm"
        >
          {{ $t('global.submit')}}
        </v-btn>
      </div>
    </v-toolbar>
    <StepFieldForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import StepFieldForm from '../../components/step/FormField';
import Loading from '../../components/Loading';
import CreateMixin from '../../mixins/CreateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'StepField';

const { mapFields } = createHelpers({
  getterType: 'stepfield/getField',
  mutationType: 'stepfield/updateField'
});

export default {
  name: 'StepFieldCreate',
  servicePrefix,
  mixins: [CreateMixin,FileMixin],
  components: {
    Loading,
    StepFieldForm
  },
  data() {
    return {
      item: {
        'step': this.$route.params.stepid
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('stepfield', ['create', 'reset']),
    onCreated(item) {
      this.showMessage(`${item['name']} ${this.$t('global.created')}`);
        this.$router.push({
        name: `StepUpdate`,
        params: { id: item['step']['@id'] , parent: item['step']['process']}
      });

    },
  },
};
</script>
